// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconRmsMicromanipulatorNeedle_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s32IconSvg = html `<svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M18 22V19.1667L16 16.8201V20H15L14 18L13 18V17H15L15.4264 16.1471L14.4488 15H13V16H12V14H13.5965L9.71749 9.44881C9.56777 9.32357 9.43666 9.17682 9.32889 9.01332L9 10H7.66667L7 8H8L9 6H10.4182C10.6023 5.94411 10.7976 5.91406 11 5.91406C11.5546 5.91406 12.0564 6.13976 12.4187 6.50431L15 8.70828V8L14 6H16V9.5621L18 11.2697V4H0V22H18ZM9 14H8V12L9 10H10V12L9 14ZM9 18H7V17H8L9 14H10.3333L11 16L10 16L9 18ZM9 18H11V19H10L9.66667 20H8L9 18ZM2.5 20L3 19H5V18H4L3 16V14H2L2 20H2.5ZM4 14V12H5V14H4ZM5 6H2V9V10H6V8H5V9H2L3 7H5V6Z" class="svg-bg"/>
  <path d="M10.8992 7.62463L30.5341 24.4545C30.5878 24.496 30.6398 24.5406 30.69 24.5882L30.6978 24.5956C30.7079 24.6053 30.7179 24.6151 30.7279 24.6251C31.5089 25.4061 31.5089 26.6725 30.7279 27.4535C29.9468 28.2346 28.6805 28.2346 27.8994 27.4535C27.8943 27.4484 27.8892 27.4433 27.8841 27.4382C27.8793 27.4334 27.8745 27.4286 27.8697 27.4236L27.8662 27.4195C27.8159 27.3668 27.7691 27.3121 27.7257 27.2556L10.8992 7.62463Z" class="svg-bg"/>
</svg>
`;
/**
 * IconRmsMicromanipulatorNeedle is a generated icon component.
 */
let IconRmsMicromanipulatorNeedle = IconRmsMicromanipulatorNeedle_1 = class IconRmsMicromanipulatorNeedle extends IconBaseElement {
    render() {
        return html `${IconRmsMicromanipulatorNeedle_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconRmsMicromanipulatorNeedle.icons = new Map([
    ['s8', _s32IconSvg],
    ['s12', _s32IconSvg],
    ['s16', _s32IconSvg],
    ['s24', _s32IconSvg],
    ['s32', _s32IconSvg],
    ['s40', _s32IconSvg],
    ['s48', _s32IconSvg],
    ['s64', _s32IconSvg],
    ['s72', _s32IconSvg],
    ['s80', _s32IconSvg],
]);
IconRmsMicromanipulatorNeedle = IconRmsMicromanipulatorNeedle_1 = __decorate([
    customElement('zui-icon-rms-micromanipulator-needle')
], IconRmsMicromanipulatorNeedle);
export { IconRmsMicromanipulatorNeedle };
